import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractBaseDetailsComponent } from '../../../core/component/abstract-base-details-component';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SOMailModel } from '../modal/so-mail-model';
import { SalesOrderModal } from '../modal/sales-order-modal';

@Component({
  selector: 'app-so-email-sender',
  templateUrl: './so-email-sender.component.html',
  styleUrls: ['./so-email-sender.component.css'],
})
export class SOEmailSenderComponent extends AbstractBaseDetailsComponent implements OnInit {
  @Input() soData: SalesOrderModal;

  @Output('onSave')
  public saveCallback: EventEmitter<SOMailModel> = new EventEmitter<SOMailModel>();

  emailData: SOMailModel;

  formEmail: FormGroup;
  submitted: boolean;

  constructor(public toaster: ToastrService, public formBuilder: FormBuilder) {
    super(toaster);
  }

  ngOnInit() {
    this.init();
    this.setData();
  }

  init() {
    this.formEmail = this.formBuilder.group({
      emailTo: ['', Validators.required],
      emailCC: [''],
      emailBcc: [''],
      subject: ['', Validators.required],
      message: [''],
    });
  }

  setData() {
    this.emailData = new SOMailModel();
    if (this.soData) {
      this.emailData.soDTO = this.soData;
      this.emailData.cc = this.soData.createdBy.email;
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.formEmail.invalid) {
      return;
    }

    this.saveCallback.emit(this.emailData);
  }

  get f() {
    return this.formEmail.controls;
  }
}
